import React from 'react';
import Head from './HeadVideo';
import { IComponentVideoHead } from '../../component';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';

const AllForVideoHead = (props: IComponentVideoHead) => {
  let { pagedataStore, galleryStore } = props.rootStore;
  const { mediaList } = galleryStore;
  return (
    <Head
      {...props}
      {...pagedataStore.getViewDetail(true)}
      mediaList={mediaList}
    />
  );
};

export default inject('rootStore')(observer(AllForVideoHead));
